__turbopack_context__.v({
  "actions": "FolderDocumentation-module__k5iF1G__actions",
  "canvasEmbedWrapper": "FolderDocumentation-module__k5iF1G__canvasEmbedWrapper",
  "dropdown": "FolderDocumentation-module__k5iF1G__dropdown",
  "emptyState": "FolderDocumentation-module__k5iF1G__emptyState",
  "menu": "FolderDocumentation-module__k5iF1G__menu",
  "menuItemText": "FolderDocumentation-module__k5iF1G__menuItemText",
  "pinned": "FolderDocumentation-module__k5iF1G__pinned",
  "pinnedActions": "FolderDocumentation-module__k5iF1G__pinnedActions",
  "pinnedTitle": "FolderDocumentation-module__k5iF1G__pinnedTitle",
  "pinnedTitleText": "FolderDocumentation-module__k5iF1G__pinnedTitleText",
  "regenerateAlertActions": "FolderDocumentation-module__k5iF1G__regenerateAlertActions",
  "regenerateAlertOverlay": "FolderDocumentation-module__k5iF1G__regenerateAlertOverlay",
  "root": "FolderDocumentation-module__k5iF1G__root",
});
